'use client';

import React, { useEffect, useState } from 'react';
import getIpFromCloudflareClient from 'utilities/src/getIpFromCloudflareClient';
import Script from './Script';

export default function LeadfeederScript() {
  const [isUS, setIsUS] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function checkCountry() {
      try {
        const cfData = await getIpFromCloudflareClient();
        if (cancelled) return;
        setIsUS(cfData?.loc === 'US');
      } catch {
        if (cancelled) return;
        setIsUS(false);
      }
    }

    checkCountry();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!isUS) return null;

  return (
    <Script id="leadfeeder">
      {`(function(ss,ex){ window.ldfdr=window.ldfdr||function(){(ldfdr._q=ldfdr._q||[]).push([].slice.call(arguments));}; (function(d,s){ fs=d.getElementsByTagName(s)[0]; function ce(src){ var cs=d.createElement(s); cs.src=src; cs.async=1; fs.parentNode.insertBefore(cs,fs); }; ce('https://sc.lfeeder.com/lftracker_v1_'+ss+(ex?'_'+ex:'')+'.js'); })(document,'script'); })('kn9Eq4RpNEK8RlvP');`}
    </Script>
  );
}
